import styles from './Loyalty.css'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Introduction from './Introduction'
import Create from './Create'
import Existing from './Existing'
import Edit from './Edit'
import Reset from './Reset'
import { dateFormatter } from 'utils/formatter'
import {
  initLoyaltyData,
  createLoyalty,
  editLoyalty,
  resetLoyalty,
  deactivateLoyalty,
  reactivateLoyalty
} from 'actions/customers/loyalty'
import {push} from 'react-router-redux'
import {askConfirmAction} from 'actions/confirm-action'
import * as mpLoyalty from 'mixpanel/customers/loyalty'
import ConfirmActionModal from 'components/ConfirmActionModal'
import FeatureBlockerPage from 'components/FeatureBlockerPage'
import MenuTitle from 'components/MenuTitle'
import {browserHistory} from 'react-router'

class Loyalty extends Component {

  constructor (props) {
    super(props)
    const views = ['introduction', 'create', 'exist', 'edit']
    this.state = {
      views,
      currentView: props.loyalty.hasLoyalty ? views[2] : views[0],
      showSuccessfulModal: false
    }
  }

  componentWillMount () {
    if (this.props.loyalty.hasLoyalty === null) {
      this.props.initLoyaltyData()
    }
  }

  componentDidMount () {
    if (Cookies.get('labelNewLoyalty') === undefined || Cookies.get('labelNewLoyalty') === 'true') {
      Cookies.set('labelNewLoyalty', 'false', { path: '/' })
    }
    const {expired} = this.props
    if (expired) {
      browserHistory.push('/settings/billing')
    }
  }

  componentWillReceiveProps (nextProps) {
    let { loyalty: { hasLoyalty } } = nextProps

    if (this.props.loyalty.hasLoyalty !== hasLoyalty) {
      if (hasLoyalty) {
        this.setState({ currentView: this.state.views[2] })
      } else {
        this.setState({ currentView: this.state.views[0] })
      }
    }
  }

  render () {
    let {user, loyalty} = this.props
    if (loyalty.hasLoyalty === null) {
      return null
    }

    let {currentView, views} = this.state
    return (
      <div>
        {currentView !== views[2] &&
          <MenuTitle menuTitle='Loyalty Program' additionalClassName='no-padding-left' />}
        <div id='loyalty-content' className={`${styles.wrapper} col-md-12`}>
          {(!user.is_owner && !loyalty.hasLoyalty) ? <FeatureBlockerPage />
          : <div className={`${styles['loyalty-container']}`}>
            {currentView === views[0] && <Introduction goToCreateView={this._showCreate} />}
            {currentView === views[1] &&
              <Create
                createLoyalty={this._createLoyalty}
                subscriptionExpiredDate={dateFormatter(this.props.user.business.expired_at, 'DD MMMM YYYY')}
                askConfirmAction={this._askConfirmAction}
                nextAction={this.props.nextAction}
                cancelProgram={this._cancelProgram}
              />
            }
            {currentView === views[2] && <Existing
              {...this.props.loyalty}
              showSuccessModal={this.state.showSuccessfulModal}
              closeSuccessModal={this._closeSuccessfulModal}
              showEdit={this._showEdit}
              showReset={this._showReset}
              reactivateLoyalty={this.props.reactivateLoyalty}
              deactivateLoyalty={this.props.deactivateLoyalty}
              />
            }
            {currentView === views[3] && <Edit {...this.props.loyalty}
              editLoyalty={this._editLoyalty}
              askConfirmAction={this._askConfirmAction}
              nextAction={this.props.nextAction}
              cancelProgram={this._cancelProgram}
              />
            }
            {currentView === views[4] && <Reset
              resetLoyalty={this._resetLoyalty}
              askConfirmAction={this._askConfirmAction}
              nextAction={this.props.nextAction}
              cancelProgram={this._cancelProgram}
              />
            }
          </div>}
          <ConfirmActionModal />
        </div>
      </div>
    )
  }

  _askConfirmAction = (location) => {
    this.props.askConfirmAction(push(location))
  }

  _createLoyalty = (data) => {
    this.props.createLoyalty(data)
    this.setState({ showSuccessfulModal: true })
  }

  _resetLoyalty = (data) => {
    this.props.resetLoyalty(data)
    this.setState({
      currentView: this.state.views[2]
    })
    mpLoyalty.resetLoyalty(data)
  }

  _editLoyalty = (data) => {
    this.props.editLoyalty(data)
    this.setState({
      currentView: this.state.views[2]
    })
    mpLoyalty.editLoyalty(data)
  }

  _showCreate = () => {
    this.setState({
      currentView: this.state.views[1]
    })
  }

  _cancelProgram = () => {
    if (this.props.loyalty.hasLoyalty) {
      this.setState({ currentView: this.state.views[2] })
    } else {
      this.setState({ currentView: this.state.views[0] })
    }
  }

  _showEdit = () => {
    this.setState({
      currentView: this.state.views[3]
    })
  }

  _showReset = () => {
    this.setState({
      currentView: this.state.views[4]
    })
  }

  _closeSuccessfulModal = () => {
    this.setState({ showSuccessfulModal: false })
  }
}

function mapStateToProps ({customers: {loyalty}, moka: {user}, confirmAction: {nextAction}, subscriptionExpired}) {
  return {
    loyalty,
    user,
    nextAction,
    expired: subscriptionExpired.expired
  }
}

export default connect(mapStateToProps, {
  initLoyaltyData,
  createLoyalty,
  editLoyalty,
  resetLoyalty,
  deactivateLoyalty,
  reactivateLoyalty,
  askConfirmAction
})(Loyalty)



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Loyalty.js